import { PaginatedRequestParams } from 'api';
import { Dayjs } from 'dayjs';
export enum UserFilterFormField {
  FullUserName = 'full_user_name',
  PhoneNumber = 'phone_number',
  Role = 'role',
  Company = 'company_id',
  Email = 'email',
}

export type UserFilterFormValues = {
  [UserFilterFormField.FullUserName]: string | undefined;
  [UserFilterFormField.PhoneNumber]: string | undefined;
  [UserFilterFormField.Email]: string | undefined;
  [UserFilterFormField.Role]: string | undefined;
  [UserFilterFormField.Company]: string | undefined;
};

export type UserFilterFormValuesPaginated = UserFilterFormValues &
  PaginatedRequestParams;

export enum EndUserFilterFormField {
  Date = 'date',
  FullUserName = 'full_user_name',
  PhoneNumber = 'phone_number',
  Email = 'email',
  Role = 'role',
}

export type EndUserFilterFormValues = {
  [EndUserFilterFormField.Date]: [Dayjs | undefined, Dayjs | undefined] | null;
  [EndUserFilterFormField.FullUserName]: string | undefined;
  [EndUserFilterFormField.PhoneNumber]: string | undefined;
  [EndUserFilterFormField.Email]: string | undefined;
  [EndUserFilterFormField.Role]: string | undefined;
};

export type EndUserFilterFormValuesPaginated = EndUserFilterFormValues &
  PaginatedRequestParams;

export type NotificationListPaginated =  PaginatedRequestParams;
 
export enum UserFormField {
  Id='UserId',
  Role = 'role',
  FirstName = 'name', 
  Email = 'email',
  PhoneNumber = 'phoneNumber',
  Password = 'password',
  ConfirmPassword = 'confirm_password',  
  IsActive= 'isActive',
  IsManualSave='isManualSave',
  Type='type'
}

export type UserFormValues = {
  [UserFormField.Id]?: string | undefined;
  [UserFormField.Role]: number;
  [UserFormField.FirstName]: string;
  [UserFormField.Email]: string;
  [UserFormField.PhoneNumber]: string;
  [UserFormField.Password]: string;
  [UserFormField.ConfirmPassword]: string;
  [UserFormField.IsActive]: boolean;
};

export enum EndUserFormField {
  FirstName = 'first_name',
  Email = 'email',
  PhoneNumber = 'phone_number',
}

export type EndUserFormValues = {
  [UserFormField.FirstName]: string;
  [UserFormField.Email]: string;
  [UserFormField.PhoneNumber]: string;
};








 
  

